import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordNotifierService {

  private _passwordNotifier = new BehaviorSubject<boolean>(false);
  public passwordNotifierObserver$: Observable<boolean> = this._passwordNotifier.asObservable();

  set notifyPassword(value: boolean) {
    this._passwordNotifier.next(value);
  }

  public async passwordChangeNotificationAsPromise(): Promise<boolean> {
    return new Promise((resolve) => {
      this.passwordNotifierObserver$.subscribe({
        next: (val) => {
          (val) ? resolve(val) : resolve(false);
        }
      });
    });
  }
}
